export enum AccountType {
  SUPPLY = 'Supply',
  DEMAND = 'Demand',
}

export enum AccountTypeValue {
  SUPPLY = 'Supplier',
  DEMAND = 'Demand',
}

export enum UserStatus {
  PRE_VETTING = 'Pre-vetting',
  APPROVED = 'Approved',
  REVOKED = 'Revoked',
}

export enum ArrowIconType {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum RegionType {
  WORLDWIDE = 'Worldwide',
  CONTINENTS = 'Continents',
  COUNTRY = 'Country',
}

export enum BusinessType {
  INDIVIDUAL = 'Individual',
  COMPANY = 'Company',
}

export enum ApplicantStatus {
  REJECTED = 'Rejected',
  ACCEPTED = 'Accepted',
  PENDING = 'Pending',
}

export enum CountryState {
  USA = 'United States',
}

export enum FileType {
  CSV = 'csv',
  TSV = 'tsv',
  XML = 'xml',
}
